 
import React, { useState } from 'react';
import AnnouncementBar from './components/AnnouncementBar';
import Hero from './components/Hero';
import LogoStrip from './components/LogoStrip';
import StatsBar from './components/StatsBar';
import Testimonial from './components/Testimonial';
import Integrations from './components/Integrations';
import TestimonialsMarquee from './components/TestimonialsMarquee';
import TrustBadges from './components/TrustBadges';
import DataQuality from './components/DataQuality';
import UseCases from './components/UseCases';
import CaseStudies from './components/CaseStudies';
import PricingTeaser from './components/PricingTeaser';
import ChromeExtension from './components/ChromeExtension';
import CTA from './components/CTA';
import Navbar from '../../components/layout/Navbar';
import Footer from '../../components/layout/Footer';
 


function LandingPage() {
  return (
    <div className="bg-white font-sans overflow-x-hidden">
      <AnnouncementBar />
      <Navbar />
      <Hero />
      <LogoStrip />
      <StatsBar />
      <Testimonial />
      <Integrations />
      <TestimonialsMarquee />
      <TrustBadges />
      <DataQuality />
      <UseCases />
      <CaseStudies />
      <PricingTeaser />
      <ChromeExtension />
      <CTA />
      <Footer />
    </div>
  );
}

export default LandingPage;
